import React, { useState } from 'react';
import Layout from 'LayoutNoneWidget'
import MiniLineChart from './MiniLineChart'
import './styles.scss'
import { Tooltip } from 'antd';

const Dashboard: React.FC = () => {

  return (
    <Layout>
      <div className="_tw">
        <div className="" data-sentry-component="PageStyleWrapper" data-sentry-source-file="PageStyleWrapper.tsx">
          <nav className="breadcrumb__container mb-3">
            <div className="breadcrumb__gradient breadcrumb__gradient--left" data-gradient="left" style={{ display: 'none' }}></div>
            <ul className="breadcrumb" data-breadcrumb-scroll-container="">
              <li className="breadcrumb-item"><a href="/accounts-overview">Trader</a></li>
              <li className="breadcrumb-item active">
                Free Trial
              </li>
            </ul>
            <div className="breadcrumb__gradient breadcrumb__gradient--right" data-gradient="right" style={{ display: 'none' }}></div>
          </nav>
          <div className="relative h-[336px] overflow-hidden rounded-[4px] bg-background-secondary" data-sentry-component="LockedContainer" data-sentry-source-file="LockedContainer.tsx" style={{ height: '488px' }}>
            <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
              <div className="col-span-2 rounded-[4px] bg-background-secondary p-6" data-sentry-component="StartWithMockData" data-sentry-source-file="OrderLockedContainersContent.tsx">
                <h5 className="m-0 text-headings-h5 text-content-primary">Start Free Trial</h5>
                <div className="mb-3 mt-2 text-labels-small text-content-tertiary">
                  Use this opportunity to get the feel of our Trading Objectives without risking anything. Be disciplined and manage your risk carefully.
                  <div className="mt-2 lg:mt-0">Our 14-day Free Trial is a shortened version of the LUMIR Challenge so you practice trading with us.</div>
                </div>
                <div className="h-px bg-separators-primary" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
                <h6 className="m-0 mt-6 text-headings-h6 text-content-primary">Account Balance</h6>
                <div className="mb-2 mt-1 text-labels-small text-content-tertiary">Trading Account Currency:</div>
              </div>
              <div className="col-span-1 mt-6 grid h-fit gap-6 lg:mt-0" data-sentry-component="SummarylWithMockData" data-sentry-source-file="OrderLockedContainersContent.tsx">
                <div className="rounded-[4px] bg-background-secondary p-6">
                  <h5 className="m-0 text-headings-h5 text-content-primary">Summary</h5>
                  <div className="mt-6 flex gap-3">
                    <div
                      aria-hidden="true"
                      className="_svgMd_12opb_8 p-[12px] rounded-[8px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                      data-sentry-component="FunctionalIcon"
                      data-sentry-source-file="FunctionalIcon.tsx"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M18.4909 6.6135L19.4725 5.27607L17.497 3.81595L16.4541 5.22699C15.4479 4.71166 14.3314 4.35583 13.1534 4.20859V2.45399H16.2209V0H7.63197V2.45399H10.6995V4.20859C5.79147 4.82209 1.98779 8.99387 1.98779 14.0614C1.98779 19.546 6.44178 24 11.9264 24C17.4111 24 21.8651 19.546 21.8651 14.0614C21.8774 11.092 20.5645 8.42945 18.4909 6.6135ZM11.9387 21.546C7.81601 21.546 4.45405 18.184 4.45405 14.0614C4.45405 9.93865 7.81601 6.57669 11.9387 6.57669C16.0614 6.57669 19.4234 9.93865 19.4234 14.0614C19.4234 18.1963 16.0614 21.546 11.9387 21.546Z"
                          fill="currentColor"
                        ></path>
                        <path d="M12.8588 8.40491H11.0183V14.0736C11.0183 14.5767 11.4355 14.9939 11.9386 14.9939H17.6073V13.1534H12.8588V8.40491Z" fill="currentColor"></path>
                      </svg>
                    </div>
                    <div>
                      <h6 className="m-0 text-headings-h6 text-content-primary">Free Trial</h6>
                      <div className="text-body-medium text-content-tertiary">$ 200.000 account</div>
                    </div>
                  </div>
                  <div className="h-px bg-separators-primary my-6" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
                </div>
              </div>
            </div>
            <div className="z-1 w-fill absolute left-0 right-0 top-0 flex flex-col items-center justify-center text-center _container_1upho_41" style={{ height: 488 }}>
              <div className="w-full max-w-full overflow-y-auto py-4 md:py-8">
                <div className="mx-5 md:mx-10 lg:mx-20">
                  <div className="mb-4 text-content-tertiary d-flex items-center justify-center">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M20.2578 8.83436V8.09816C20.2578 3.6319 16.5515 0 11.9937 0C7.43597 0 3.72965 3.6319 3.72965 8.09816V8.83436H1V24H23V8.83436H20.2578ZM6.23392 8.09816C6.23392 4.9816 8.81332 2.45399 11.9937 2.45399C15.1742 2.45399 17.7536 4.9816 17.7536 8.09816V8.83436H6.23392V8.09816ZM20.4957 21.546H3.50427V11.2883H20.4832V21.546H20.4957Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M11.9936 13.4355C11.0295 13.4355 10.2532 14.1963 10.2532 15.1411C10.2532 15.7791 10.6163 16.3313 11.1547 16.6257V19.411H12.8451V16.6257C13.3835 16.3313 13.7466 15.7791 13.7466 15.1411C13.7466 14.1963 12.9578 13.4355 11.9936 13.4355Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                  <h6 className="m-0 text-headings-h6">Active Free Trial Detected</h6>
                  <div className="text-body-medium text-content-tertiary mt-[4px]">
                    <div>
                      You currently have an active Free Trial (Login: 1510971109). To start a new one, please end your current trial first.
                      <div className="_link_1iyjb_7" data-sentry-component="LimitedHTML" data-sentry-source-file="LimitedHTML.tsx">Learn more about managing Free Trial settings <a href="https://lumir.finance">here</a>.</div>
                    </div>
                  </div>
                </div>
                <div className="mt-6 flex justify-center"><a className="z-2 btn btn-primary cursor-pointer" href="/accounts-overview">Back to Accounts Overview</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default Dashboard